var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQuestion = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_4"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    id: "svg_1",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m9.3375,27.23521l-4.44921,-4.44915c-0.77141,-0.77195 -1.20456,-1.81858 -1.20456,-2.90992l0,-7.56491c0,-1.09148 0.43401,-2.13818 1.20593,-2.90988l4.44921,-4.44921c0.7717,-0.77192 1.8184,-1.20593 2.90988,-1.20593l7.56491,0c1.09148,0 2.13825,0.43401 2.90992,1.20593l4.45065,4.45059c0.7714,0.77192 1.20448,1.81861 1.20448,2.90988l0,7.56353c0,1.09134 -0.43308,2.13797 -1.20448,2.90992l-4.44928,4.45052c-0.77222,0.77181 -1.81954,1.20516 -2.91129,1.20461l-7.56491,0c-1.09196,0 -2.13922,-0.43363 -2.91125,-1.20599l0,0z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    id: "svg_2",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m16.03127,17.06936l1.82064,-1.01152c0.90853,-0.50467 1.47203,-1.4623 1.47203,-2.50166c-0.10765,-1.72836 -1.58983,-3.04593 -3.319,-2.95019c-1.54485,-0.06414 -2.91691,0.98023 -3.26634,2.48653"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    id: "svg_3",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m16.16854,21.44445c0,0.0757 -0.06144,0.137 -0.13727,0.137c-0.0757,0 -0.137,-0.06144 -0.13714,-0.13714c0,-0.0757 0.0613,-0.13714 0.13714,-0.13727c0.03634,0 0.07131,0.0144 0.09709,0.04018c0.02578,0.02578 0.04032,0.06075 0.04018,0.09723"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question.1808662e.svg";
export { ForwardRef as ReactComponent };